import React, { Fragment } from 'react'
import { Button, Form } from 'react-bootstrap'
import { FaEnvelope } from 'react-icons/fa6'
import useForgot from '../../Hooks/Auth/useForgot'
import InputIcon from '../Main/InputIcon'
import Loader from '../Main/Loader'

const ForgotPasswordPage = () => {

    const [
        email,
        isLoading,
        handleEmail,
        handleSubmit,
    ] = useForgot();

    return (
        <Fragment>

            <div className="auth-background" style={{ height: "100vh" }}>
                <div className="overlay h-100" >
                    <div className="container">
                        <div className="row ">
                            <div className="col-lg-5 my-5">
                                <div className="mt-5 card bg-white border-0 p-5">
                                    <h5 className='heading'>
                                        Forgot Password
                                    </h5>

                                    <p>
                                        Enter Email For OTP
                                    </p>

                                    <Form onSubmit={handleSubmit} className='row'>
                                        <InputIcon
                                            type="email"
                                            placeholder="Email"
                                            icon={<FaEnvelope />}
                                            handleChange={handleEmail}
                                            value={email} />
                                        <div className='p-0'>
                                            <Button type='submit' className='btn btn-danger w-100 py-3'>
                                                {isLoading ? <Loader /> : "Submit"}
                                            </Button>
                                        </div>
                                    </Form>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default ForgotPasswordPage